import React from "react";
import styled from "styled-components";
import { ContentWrapper } from "../pages/InsuranceGuidance";

const About = () => {
  return (
    <Wrapper>
      <ContentWrapper>
        <Content>
          <h1>
            Helping People <span>Understand Insurance</span> with Confidence
          </h1>
          <p>
            Wealthies is a platform focused on simplifying insurance awareness
            and helping individuals connect with licensed insurance
            professionals.
          </p>
          <p>
            Our goal is to make insurance concepts easier to understand so
            individuals and families can explore financial protection options
            with greater clarity.
          </p>
          <p>
            Through educational guides, knowledge resources, and advisor
            connections, Wealthies aims to make the insurance journey more
            transparent and easier to navigate.
          </p>

          <h2>Our Mission</h2>
          <p>
            Our mission is to simplify insurance awareness and help individuals
            make informed financial protection decisions.
          </p>
          <p>
            Insurance is often considered an important part of financial
            planning, but many people find policy terms, coverage details, and
            benefits difficult to understand.
          </p>
          <p>
            Wealthies aims to bridge this gap by providing educational resources
            and helping individuals connect with licensed insurance
            professionals who can assist them further.
          </p>

          <h2>
            What <span>We Do</span>
          </h2>
          <h5>Insurance Education</h5>
          <p>
            Our platform provides simple guides and articles designed to help
            individuals understand insurance concepts in clear and practical
            language.
          </p>
          <p>
            These guides explain important topics such as term insurance, health
            insurance, and financial protection planning.
          </p>

          <h5>Advisor Connection</h5>
          <p>
            Individuals visiting Wealthies can submit requests to connect with
            licensed insurance professionals who can help explain policy options
            and coverage features.
          </p>
          <p>
            This connection helps individuals explore insurance solutions with
            professional assistance.
          </p>

          <h5>Wealthies Shield Support</h5>
          <p>
            Wealthies also provides guidance support through the Wealthies
            Shield initiative, which helps customers understand claim
            procedures, documentation requirements, and policy-related
            processes.
          </p>
          <p>
            This support is designed to make the insurance experience more
            transparent and easier to manage.
          </p>

          <h2>Our Approach</h2>
          <Cards>
            <Card>
              <Icon className="fa-solid fa-lightbulb"></Icon>
              <CardContent>
                <h5>Understand Insurance</h5>
                <p>Clarify Policy Terms, Coverage & Benefits</p>
              </CardContent>
            </Card>
            <Card>
              <Icon className="fa-solid fa-book-open"></Icon>
              <CardContent>
                <h5>Educational Resources</h5>
                <p>
                  Provide access to educational financial Resources & Guides
                </p>
              </CardContent>
            </Card>
            <Card>
              <Icon className="fa-solid fa-handshake"></Icon>
              <CardContent>
                <h5>Advisor Connections</h5>
                <p>Connect individuals with licensed insurance professionals</p>
              </CardContent>
            </Card>
            <Card>
              <Icon className="fa-solid fa-shield-halved"></Icon>
              <CardContent>
                <h5>Wealthies Shield</h5>
                <p>Offer guidance support through Wealthies Shield</p>
              </CardContent>
            </Card>
          </Cards>

          <h2 style={{ marginTop: "35px" }}>Our Commitment</h2>
          <p>
            At Wealthies, we believe financial awareness should be accessible to
            everyone.
          </p>
          <p>
            We are committed to providing clear information, transparent
            communication, and helpful guidance so individuals can better
            understand insurance and financial protection options.
          </p>
        </Content>
      </ContentWrapper>
    </Wrapper>
  );
};

export default About;

export const BrandWrapper = styled.span`
  color: #005f73 !important;
  font-weight: bold;
`;
const Wrapper = styled.div`
  padding: 80px 5%;
  max-width: 1400px;
  margin: 0 auto;

  #heading {
    text-align: center;
    font-size: 2.8rem;
    color: #005f73;
    margin-bottom: 40px;
  }
  span {
    color: #fdc500;
  }
`;

export const Content = styled.div`
  flex: 1 1 40%;
  display: flex;
  flex-direction: column;
  /* max-width: 60%; */

  h1 {
    font-size: 2.5rem;
    /* color: #344e41; */
    margin: 0;
  }

  h1,
  h2 {
    color: #005f73;
  }
  h2 span {
    color: #fdc500;
  }

  p {
    font-size: 1.1rem;
    line-height: 1.7;
    color: #333;
  }

  /* h2 {
    text-align: center;
  } */

  @media (max-width: 900px) {
    h1 {
      font-size: 2rem;
    }
  }
`;

export const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px;
  /* margin-top: 80px; */

  .card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 20px;
  }

  .card-body i {
    font-size: 2rem;
    background: linear-gradient(135deg, #005f73, #00aaff);
    color: #fff;
    padding: 18px;
    border-radius: 50%;
    box-shadow: 0 8px 20px rgba(0, 119, 204, 0.3);
    transition: transform 0.4s ease;
  }

  .card:hover .card-body i {
    transform: scale(1.2) rotate(10deg);
  }

  .card-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .card-content h5 {
    font-size: 1.4rem;
    color: #003366;
    margin: 0;
  }

  .card-content p {
    font-size: 1.1rem;
    color: #333;
    margin: 0;
    line-height: 1.5;
  }

  @media (max-width: 900px) {
    gap: 30px;

    .card {
      width: 90%;
    }
  }
`;

export const Card = styled.div`
  position: relative;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(12px);
  border-radius: 20px;
  padding: 50px 30px 30px;
  width: 300px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition:
    transform 0.4s ease,
    box-shadow 0.4s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;

  &:hover {
    transform: translateY(-15px);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  }
`;

export const Icon = styled.i`
  font-size: 2.2rem;
  color: #005f73;
`;

export const CardContent = styled.div`
  h5 {
    font-size: 1.3rem;
    color: #005f73;
    margin: 0 0 5px 0;
  }

  p {
    margin: 0;
    color: #555;
    font-size: 1rem;
    text-align: left;
  }
`;
